import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import DomainDetails from './DomainDetails';
import { addItemToCart, removeItemFromCart } from '../../actions/cartAction';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const RegisterDomainTable = ({ data }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isDetailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedDomainInfo, setSelectedDomainInfo] = useState({});

  const items = useSelector(({ cart }) => cart.items);

  const onModalCancel = () => setDetailModalVisible(false);
  const onDetailClick = (info) => {
    return () => {
      setSelectedDomainInfo(info);
      setDetailModalVisible(true);
    };
  };

  const onAddToCartClick = ({ name, tld, price, period }) => {
    return () => {
      dispatch(addItemToCart(name, tld, price, period));
    };
  };

  const onRevemoFromCartClick = ({ domain }) => {
    return () => {
      dispatch(removeItemFromCart(domain));
    };
  };

  const isDomainInCart = (domain) => {
    const isInCart = items.filter((item) => item.title === domain);

    return isInCart.length;
  };

  const status = (available) => (available ? 'Available' : 'Unavailable');
  const cartButtonTitle = (domain) => (isDomainInCart(domain) ? 'Remove from cart' : 'Add to Cart');
  const cartButtonAction = (row) =>
    isDomainInCart(row.domain) ? onRevemoFromCartClick(row) : onAddToCartClick(row);

  return (
    <div>
      <DomainDetails
        info={selectedDomainInfo}
        onCancel={onModalCancel}
        visible={isDetailModalVisible}
      />
      <TableContainer component={Paper}>
        <Table aria-label="simple table" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Domain Name</TableCell>
              <TableCell align="right">Status</TableCell>
              <TableCell align="right">Price in $ / 1 Year</TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  {row.domain ? row.domain : row.name + row.tld}
                </TableCell>
                <TableCell align="right">{status(row.available)}</TableCell>
                <TableCell align="right">{row.price || '-'}</TableCell>
                <TableCell align="right">
                  <Button onClick={row.available ? cartButtonAction(row) : onDetailClick(row)}>
                    {row.available ? cartButtonTitle(row.domain) : 'Details'}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default RegisterDomainTable;
